import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    labelMap: {}
  },
  getters: {
    getLabelsByType: (state) => (labelType) => {
      if(state.labelMap[labelType] == null)
        return []
      return state.labelMap[labelType]
    }
  },
  mutations: {
    // Set labels of a particular label type based on response of '/labels' API call
    updateLabels (state, payload) {
      // Use Vue.set for reactive changes to the array
      Vue.set(state.labelMap, payload.labelType, payload.labelList)
    }
  }
}
